module.exports = __webpack_public_path__ + "img/exam_icon_white.d8d88ec1.svg";